/**
 * 보험 약효분류번호(meftDivNo) → 분류명 매핑.
 * 처방 스냅샷의 meftDivNo로 약효군 그룹 헤더에 이름을 표시한다.
 * 정확 매칭이 없으면 앞 3자리(대분류)로 폴백한다(meftDivName 헬퍼).
 */
export const MEFT_DIV_CATEGORIES: Record<string, string> = {
  "100": "신경계 감각기관용 의약품",
  "110": "중추신경계용약",
  "111": "전신마취제",
  "112": "최면진정제",
  "113": "항전간제",
  "114": "해열, 진통, 소염제",
  "115": "각성제, 흥분제",
  "116": "진훈제",
  "117": "정신신경용제",
  "119": "기타의 중추신경용약",
  "120": "말초신경계용약",
  "121": "국소마취제",
  "122": "골격근이완제",
  "123": "자율신경제",
  "124": "진경제",
  "125": "발한제, 지한제",
  "129": "기타의 말초신경용약",
  "130": "감각기관용약",
  "131": "안과용제",
  "132": "이비과용제",
  "139": "기타의 감각기관용약",
  "140": "알레르기용약",
  "141": "항히스타민제",
  "142": "자격료법제(비특이성 면역원제포함)",
  "149": "기타의 알레르기용약",
  "190": "기타의 신경계 및 감각기관용의약품",
  "200": "개개의 기관계용 의약품",
  "210": "순환계용약",
  "211": "강심제",
  "212": "부정맥용제",
  "213": "이뇨제",
  "214": "혈압강하제",
  "215": "혈관보강제",
  "216": "혈관수축제",
  "217": "혈관확장제",
  "218": "동맥경화용제",
  "219": "기타의순환계용약",
  "220": "호흡기관용약",
  "221": "호흡촉진제",
  "222": "진해거담제",
  "223": "함소흡입제",
  "229": "기타의 호흡기관용약",
  "230": "소화기관용약",
  "231": "치과구강용약",
  "232": "소화성궤양용제",
  "233": "건위소화제",
  "234": "제산제",
  "235": "최토제, 진토제",
  "236": "이담제",
  "237": "정장제",
  "238": "하제, 완장제",
  "239": "기타의 소화기관용약",
  "240": "호르몬제(항호르몬제를 포함)",
  "241": "뇌하수체호르몬제",
  "242": "수액신호르몬제",
  "243": "갑상선, 부갑상선호르몬제",
  "244": "단백동화스테로이드제",
  "245": "부신호르몬제",
  "246": "남성호르몬제",
  "247": "난포호르몬제 및 황체호르몬제",
  "248": "혼합호르몬제",
  "249": "기타의 호르몬제(항호르몬제를 포함)",
  "250": "비뇨생식기관 및 항문용약",
  "251": "요로소독제",
  "252": "자궁수축제",
  "253": "통경제",
  "254": "피임제",
  "255": "비뇨생식기관용제(성병예방제포함)",
  "256": "치질용제",
  "259": "기타의 비뇨생식기관 및 항문용약",
  "260": "외피용약",
  "261": "외피용살균소독제",
  "262": "창상보호제",
  "263": "화농성질환용제",
  "264": "진통, 진양, 수렴, 소염제",
  "265": "기생성 피부질환용제",
  "266": "피부연화제(부식제를 포함)",
  "267": "모발용제(발모, 탈모, 염모, 양모제)",
  "268": "욕제",
  "269": "기타의 외피용약",
  "290": "기타의 개개의 기관용 의약품",
  "300": "대사성 의약품",
  "310": "비타민제",
  "311": "비타민A 및 D제",
  "312": "비타민Bl제",
  "313": "비타민B제(비타민Bl을 제외)",
  "314": "비타민C 및 P제",
  "315": "비타민E 및 K제",
  "316": "혼합비타민제(비타민A,D 혼합제를 제외)",
  "319": "기타의 비타민제",
  "320": "자양강장변질제",
  "321": "칼슘제",
  "322": "무기질제제",
  "323": "당류제",
  "324": "유기산제제",
  "325": "단백아미노산제제",
  "326": "장기제제",
  "327": "유유아용제",
  "329": "기타의 자양강장변질제",
  "330": "혈액 및 체액용약",
  "331": "혈액대용제",
  "332": "지혈제",
  "333": "혈액응고저지제",
  "339": "기타의 혈액 및 체액용약",
  "340": "인공관류용제",
  "341": "인공신장관류용제",
  "349": "기타의 인공관류용제",
  "390": "기타의 대사성 의약품",
  "391": "간장질환용제",
  "392": "해독제",
  "393": "습관성중독용제",
  "394": "통풍치료제",
  "395": "효소제제",
  "396": "당뇨병용제",
  "398": "종합대사성제제",
  "399": "따로 분류되지 않는 대사성 의약품",
  "400": "조직세포의 기능용 의약품",
  "410": "조직부활용약",
  "411": "클로로필제제",
  "412": "색소제제",
  "419": "기타의 세포부활용약",
  "420": "종양용약",
  "421": "항악성종양제",
  "429": "기타의 종양치료제",
  "430": "조직세포의 치료 및 진단 목적",
  "431": "방사성 의약품",
  "439": "기타의 조직세포의 치료 및 진단",
  "490": "기타의 조직세포의 기능용의약품",
  "600": "항병원생물성 의약품",
  "610": "항생물질제제",
  "611": "주로 그람양성균에 작용하는 것",
  "612": "주로 그람음성균에 작용하는 것",
  "613": "주로 항산성균에 작용하는 것",
  "614": "주로 그람양성균, 리케치아, 비루스에 작용하는 것",
  "615": "주로 그람음성균, 리케치아, 비루스에 작용하는 것",
  "616": "주로 곰팡이, 원충에 작용하는 것",
  "617": "주로 악성종양에 작용하는 것",
  "618": "주로 그람양성, 음성균에 작용하는 것",
  "619": "기타의 항생물질 제제(복합항생물질제제를 포함)",
  "620": "화학료법제",
  "621": "설화제",
  "622": "항결핵제",
  "623": "치나제",
  "624": "구매제",
  "625": "후란계 제제",
  "629": "기타의 화학료법제",
  "630": "생물학적 제제",
  "631": "백신류",
  "632": "독소류 및 톡소이드류",
  "633": "항독소 및 렙토스피라혈청류",
  "634": "혈액제제류",
  "635": "생물학적 시험용제제류",
  "636": "생물학적 제제",
  "639": "기타의 생물학적 제제",
  "640": "기생동물에 대한 의약품",
  "641": "항원충제",
  "642": "구충제",
  "649": "기타의 기생동물에 대한 의약품",
  "690": "기타의 병원생물에 대한 의약품",
  "700": "치료를 주목적으로 하지 않는 의약품 및 관련제품",
  "710": "조제용약",
  "711": "부형제",
  "712": "연고기제",
  "713": "용해제",
  "714": "교미교취착색제",
  "715": "유화제",
  "719": "기타의 조제용약",
  "720": "진단용약",
  "721": "X선조영제",
  "722": "일반검사용 시약",
  "723": "혈액검사용 시약",
  "724": "생화학적 검사용 시약",
  "725": "면역혈청학적 검사용 시약",
  "726": "세균학적 검사용제",
  "727": "병리조직검사용 시약",
  "728": "기능검사용 시약",
  "729": "기타의 진단용약",
  "730": "공중위생용약",
  "731": "방부제",
  "732": "방역용 살균소독제",
  "733": "방충제",
  "734": "살충제",
  "739": "기타의 공중위생용약",
  "740": "관련제품",
  "741": "캅셀류",
  "790": "기타의 치료를 주목적으로 하지 않는 의약품",
  "791": "반창고",
  "799": "따로 분류되지 않고 치료를 주목적으로 하지 않는 의약품",
  "800": "마약",
  "810": "알카로이드 마약(천연)",
  "811": "아편알카로이드계 제제",
  "812": "코카알카로이드계 제제",
  "819": "기타의 알카로이드계 마약(천연마약)",
  "820": "비알카로이드계 마약",
  "821": "합성마약",
  "829": "기타의 비알카로이드계 마약",
  "890": "기타의 마약",
  "1100": "의료용구",
  "2000": "화장품",
  "2010": "어린이용제품류(의약부외품에 해당되는 것은 제외)",
  "2020": "목욕용제품류(의약부외품에 해당되는 것은 제외)",
  "2030": "눈화장용 제품류",
  "2040": "방향용제품류",
  "2050": "두발용제품류",
  "2060": "염모용제품류(의약부외품에 해당 되는 것은 제외)",
  "2070": "메이컵용제품류",
  "2080": "메니큐어용제품류",
  "2090": "면도용제품류",
  "2100": "기초화장품제품류(의약부외품에 해당되는 것은 제외)",
  "2110": "일소 및 일소방지용 제품류",
  "2190": "기타 화장품류(따로 분류되지 않는 화장품)",
};

/** meftDivNo → 분류명. 정확 매칭 없으면 앞 3자리(대분류)로 폴백. */
export function meftDivName(code?: string | null): string {
  if (!code) return "";
  return MEFT_DIV_CATEGORIES[code] || MEFT_DIV_CATEGORIES[code.slice(0, 3)] || "";
}
